
export class SignatureModel {
    name : string;
    signatureDate : string;

    constructor(data){
        Object.assign(this, data);
    }
}